import { State } from "country-state-city";
import { useEffect, useState } from "react";
import { AiOutlineUser } from "react-icons/ai";
import { IoMailOutline } from "react-icons/io5";
import {
  MdOutlineFlag,
  MdOutlineLocationCity,
  MdOutlinePhoneAndroid,
} from "react-icons/md";
import { Button, Col, Modal, ModalBody, Row } from "reactstrap";
import { useTranslation } from "../../languages";
import AvatarInput from "../inputs/AvatarInput";
import HorizontalCountry from "../inputs/countryCitySelect/HorizontalCountry";
import IconedInput2 from "../inputs/IconedInput2";
import SimpleDropdownInput2 from "../inputs/SimpleDropdownInput2";
const PersonalInformationModal = ({
  isOpen,
  setisOpen,
  personalDetails,
  setPersonalDetails,
  onPressSaveBtn,
}) => {
  const [stateOptions, setStateOptions] = useState([]);
  useEffect(() => {
    console.log("country selected", personalDetails?.country);
    let states = State.getStatesOfCountry(personalDetails?.country);
    setStateOptions(states);
  }, [personalDetails?.country]);
  const { t } = useTranslation();
  return (
    <Modal
      size="lg"
      fade={false}
      centered
      isOpen={isOpen}
      toggle={() => setisOpen((prev) => !prev)}
    >
      <ModalBody className="bg-white" style={{ borderRadius: "40px" }}>
        <div className="text-center mt-3 mb-4 d-flex flex-column align-items-center">
          <h4 className="mb-4 position-relative f-6 figma-shadowed-black-text">
            {t("personalInformation")}
          </h4>
          <AvatarInput
            value={personalDetails?.profile}
            setValue={(v) =>
              setPersonalDetails((prev) => ({ ...prev, profile: v }))
            }
          />
        </div>
        <Row className="g-4">
          <Col md={6}>
            <IconedInput2
              icon={<AiOutlineUser size={23} />}
              placeholder={"First name"}
              value={personalDetails?.firstName}
              setValue={(v) =>
                setPersonalDetails((prev) => ({ ...prev, firstName: v }))
              }
              type={"text"}
            />
          </Col>
          <Col md={6}>
            <IconedInput2
              icon={<AiOutlineUser size={23} />}
              placeholder={"Last name"}
              value={personalDetails?.lastName}
              setValue={(v) =>
                setPersonalDetails((prev) => ({ ...prev, lastName: v }))
              }
              type={"text"}
            />
          </Col>
          <Col md={6}>
            <SimpleDropdownInput2
              value={personalDetails?.age}
              setValue={(v) =>
                setPersonalDetails((prev) => ({ ...prev, age: v }))
              }
              options={Array.from(
                { length: 100 },
                (_, index) => `${index + 1} `
              )}
              type={"select"}
            />
          </Col>
          <Col md={6}>
            <IconedInput2
              icon={<IoMailOutline size={23} />}
              placeholder={"Write name"}
              value={personalDetails?.email}
              setValue={(v) =>
                setPersonalDetails((prev) => ({ ...prev, email: v }))
              }
            />
          </Col>
          <Col md={6}>
            <IconedInput2
              icon={<MdOutlinePhoneAndroid size={23} />}
              placeholder={"Write Country Code"}
              value={personalDetails?.countryCode}
              setValue={(v) =>
                setPersonalDetails((prev) => ({ ...prev, countryCode: v }))
              }
            />
          </Col>
          <Col md={6}>
            <IconedInput2
              icon={<MdOutlinePhoneAndroid size={23} />}
              placeholder={"Write phone number"}
              value={personalDetails?.number}
              setValue={(v) =>
                setPersonalDetails((prev) => ({ ...prev, number: v }))
              }
            />
          </Col>
          {/* <Col md={6}>
            <SimpleDropdownInput2
              icon={<GrLocation size={23} />}
              value={personalDetails?.location}
              setValue={(v) =>
                setPersonalDetails((prev) => ({ ...prev, location: v }))
              }
              options={[
                personalDetails?.location,
                "location get",
                "location from api",
                "something like that maybe",
              ]}
              type={"select"}
            />
          </Col> */}
          <HorizontalCountry
            country={personalDetails?.country}
            city={personalDetails?.city}
            setCountry={(v) =>
              setPersonalDetails((prev) => ({ ...prev, country: v }))
            }
            setCity={(v) =>
              setPersonalDetails((prev) => ({ ...prev, city: v }))
            }
            colSize={6}
            personal={true}
            countryIcon={<MdOutlineFlag />}
            cityIcon={<MdOutlineLocationCity />}
          />
          {/* <Col md={6}>
            <SimpleDropdownInput2
              placeholder={"Select Gender"}
              options={["male", "female", "both"]}
              value={personalDetails?.gender}
              setValue={(v) =>
                setPersonalDetails((prev) => ({ ...prev, gender: v }))
              }
            />
          </Col> */}
        </Row>
        <Row className="justify-content-center mt-5 mb-3">
          <Col md={6}>
            <Button
              onClick={() => {
                // userLogin({ ...user, ...personalDetails });
                onPressSaveBtn();
              }}
              className="standard-rounded-btn full-width"
            >
              {t("save")}
            </Button>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};
export default PersonalInformationModal;
